export default __webpack_public_path__ + "static/media/46t.e89bdde4.jpg";